import { css } from '@emotion/css';
import { A } from '@solidjs/router';
import { Component } from 'Shared/frontend/widgets/Component';
import { LinkLayout } from 'Shared/model/Components';
import { theme } from 'Shared/frontend/SettingsProvider';

export function Link(P:LinkLayout)
{
	const linkStyle = css(
		theme().a
	);

//FIXME clicking on a '#widget2' twice doesn't work as the link is appended to the URL. 

	return (
		<A href={P.link ?? ''} class={linkStyle} target={!P.openInSameWindow ? '_blank' : '_self'}>
			<Component {...P.content} />
		</A>
	);
}

